import oidc from './oidc';

angular.module('signalview.oidc', ['sfx.security', 'signalboost']).component('oidc', oidc);
